import { createFileRoute } from '@tanstack/react-router';

import { EncountersPage } from '@/features/emr/pages/EncountersPage';

export const Route = createFileRoute('/_authenticated/encounters/')({
  component: EncountersPage,
  beforeLoad: () => ({
    breadcrumbs: [{ href: '/encounters', title: 'Encounters' }],
  }),
});
